import { Box, Grid, Text } from '@customerio/pluma-components/react';

type MetadataRowProps = { label: string; children: React.ReactNode };

export function MetadataRow({ label, children }: MetadataRowProps) {
  return (
    <Grid columns="80px 1fr" gap="100" alignItems="center">
      <Text size="xxs" color="secondary">
        {label}
      </Text>
      <Box minW="0">{children}</Box>
    </Grid>
  );
}
